import { render, staticRenderFns } from "./trendpk10.vue?vue&type=template&id=3bda18f4"
import script from "./trendpk10.vue?vue&type=script&lang=js"
export * from "./trendpk10.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports